<template>
    <v-card class="card" :class="spaceAlignment ? ('space-on-' + spaceAlignment) : ''" :id="`${baseId}-card`">
        <div class="card-space" :id="`${baseId}-card-space`">
            <slot name="space"></slot>
        </div>
        <div class="card-content" :id="`${baseId}-card-content`">
            <slot name="content"></slot>
        </div>
    </v-card>
</template>

<script>

export default {
    props: {
        spaceAlignment: {
            type: String,
            required: false,
            default: 'left',
            validator (value) {
                return ['top', 'bottom', 'left', 'right'].indexOf(value) >= 0
            }
        },
        parentId: {
            type: String,
            required: false
        }
    },
    computed: {
        baseId: function () {
            const defaultBase = 'card-with-space'
            if (this.parentId) {
                return `${this.parentId}-${defaultBase}`
            } else {
                return defaultBase
            }
        }
    }
}

</script>

<style lang="scss" scoped>

.card {
    display:flex;
    flex-wrap: nowrap;
    height: 100%;
    padding: 20px;

    .card-space {
        flex-grow: 0;
        flex-shrink: 0;
        border-radius: 0 !important;
    }

    .card-content {
        flex-grow: 1;
        flex-shrink: 1;
        border-radius: 0 !important;
    }

    &.space-on-top,
    &.space-on-bottom {
        flex-direction: column;

        .card-space {
            width: 100%;
        }

        .card-content {
            width: 100%;
        }
    }

    &.space-on-top {
        .card-space {
            order: 1;
        }

        .card-content {
            order: 2;
        }
    }

    &.space-on-bottom {
        .card-space {
            order: 2;
        }

        .card-content {
            order: 1;
        }
    }

    &.space-on-left,
    &.space-on-right {
        flex-direction: row;

        .card-space {
            height: 100%;
        }

        .card-content {
            height: 100%;
        }
    }

    &.space-on-left {
        .card-space {
            order: 1;
        }

        .card-content {
            order: 2;
        }
    }

    &.space-on-right {
        .card-space {
            order: 2;
        }

        .card-content {
            order: 1;
        }
    }
}

</style>
